import {
  FloppyDisk1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onSearch?: () => void;
  onRefresh?: () => void;
  onFixedColumns?: () => void;
  onExportData?: () => void;
  onEditPrintTemplate?: () => void;
  className?: string;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearch,
  onRefresh,
  onFixedColumns,
  onExportData,
  onEditPrintTemplate,
  className
}) => {
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Khởi tạo, xác thực và thay thế hóa đơn điện tử</h1>
          <span className='flex items-center justify-center text-xs font-semibold text-gray-500'>
            <div className='mr-2 size-2 rounded-full bg-red-500' />
            Xác thực hóa đơn mới [Hóa đơn bán hàng] từ ngày 01/04/2025 đến ngày 05/04/2025
          </span>
        </div>
      }
    >
      {onRefresh && <ActionButtonV2 icon={FloppyDisk1Stroke} title='Xác thực HDDT' onClick={onRefresh} />}
      <MenuButtonV2
        title='In ấn'
        icon={<Lineicons aria-hidden='true' icon={PrinterStroke} size={18} />}
        items={[
          { title: 'Mẫu HĐĐT nháp', icon: <AritoIcon icon={16} />, onClick: () => {} },
          { title: 'Mẫu in hóa đơn điện tử', icon: <AritoIcon icon={16} />, onClick: () => {} },
          { title: 'Mẫu in chuyển đổi hóa đơn điện tử', icon: <AritoIcon icon={16} />, onClick: () => {} },
          { title: 'Chuyển đổi hóa đơn điện tử (Viettel)', icon: <AritoIcon icon={16} />, onClick: () => {} }
        ]}
      />
      {onSearch && <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearch} />}
      {onExportData && <ActionButtonV2 icon={RefreshCircle1ClockwiseStroke} title='Refresh' onClick={onExportData} />}
      <MenuButtonV2
        items={[
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Gửi email',
            icon: <AritoIcon icon={584} />,
            onClick: onSearch,
            group: 0
          },

          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
